import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Forecast/Forecast.requests'

export default (id: number) => {
    return useRequest({
        key: RequestKeys.getForecastById,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
    })
}
